import { ensureStructure } from '../../../helpers/ComponentHelper'

/* eslint-disable */
/* istanbul ignore next */
const findWindow = typeof window === 'undefined' ? {} : window

const buildEvent = (eventName, eventAction, interaction = null) => {
  const event = {
    eventInfo: {
      eventName,
      eventAction
    },
    attributes: {
      interaction
    }
  }
  return event
}

const productFinderOrigin = (categoryId, searchTerm) => {
  if (categoryId) {
    window.digitalData.page.productFinder.categoryId = categoryId
  } else {
    window.digitalData.page.productFinder.searchTerm = searchTerm
  }
}

const onProductFinderLoaded = (categoryId, searchTerm) => {
  ensureStructure(window)

  const event = buildEvent('productFinderLoaded', 'Product Finder Loaded', 'loaded')
  ensureStructure(window)
  productFinderOrigin(categoryId, searchTerm)
  window.digitalData.event.push(event)
  return window.digitalData.track(event.eventInfo.eventName)
}

const onProductFinderInteraction = (data, interaction) => {
  const { categoryId, steps, activeFilters, searchTerm } = data
  ensureStructure(window)
  const event = buildEvent('productFinderInteraction', 'Product Finder Interaction', interaction)
  productFinderOrigin(categoryId, searchTerm)
  window.digitalData.page.productFinder.steps = formatSteps(steps, activeFilters)
  window.digitalData.event.push(event)
  return window.digitalData.track(event.eventInfo.eventName)
}

const formatSteps = (steps, activeFilters) =>
  steps.map((step) => ({
    name: step.name,
    filters: step.filters.map((filter) => ({
      filterType: step.filterType,
      label: filter.label ? filter.label : filter.mainImage.altText,
      selected: isActiveFilter(filter.values, step.filterType, activeFilters)
    }))
  }))

const isActiveFilter = (filterValue, filterType, activeFilters) =>
  activeFilters[filterType] !== undefined && activeFilters[filterType].length > 0 &&
  filterValue.split(',').every((value) => activeFilters[filterType].includes(value))

export { onProductFinderLoaded, onProductFinderInteraction, buildEvent, ensureStructure }
